import { Mark } from 'tiptap'
import { toggleMark, markInputRule, markPasteRule } from 'tiptap-commands'

export default class JustifyMark extends Mark {

  get name() {
    return 'justifymark'
  }

  get schema() {
    return {
      attrs: {
        textAlign: {
          default: 'left',
        },
      },
      content: 'inline*',
      defining: true,
      draggable: false,
      parseDOM: [{
        tag: `span[style="text-align:justify; display:block;"]`,
        attrs: { textAlign: 'justify' },
      }],
      toDOM: (node) => ['span', { style: `text-align:justify; display:block;` }, 0],
    }
  }

  commands({ type }) {
    return (attrs) => toggleMark(type, attrs)
  }

  // inputRules({ type }) {
  //   return [
  //     markInputRule(/(?:\*\*|__)([^*_]+)(?:\*\*|__)$/, type),
  //   ]
  // }

  // pasteRules({ type }) {
  //   return [
  //     markPasteRule(/(?:\*\*|__)([^*_]+)(?:\*\*|__)/g, type),
  //   ]
  // }

}
